import * as moment from 'moment';
const TO_BE_CONFIRMED = 'To be confirmed';
export const mapUtcDate = (dateUtc: string): string => {
    try {
        return dateUtc ? moment.utc(dateUtc).local().format('DD MMM YY ha') : TO_BE_CONFIRMED;
    } catch (err) {
        return 'N/A';
    }
};

export const mapUtcDateHumanFriendly = (dateUtc: string): string => {
    try {
        return  dateUtc ? moment.utc(dateUtc).local().calendar(null, {
            sameDay: '[Today] ha',
            nextDay: '[Tomorrow] ha',
            nextWeek: 'dddd ha',
            lastDay: '[Yesterday] ha',
            lastWeek: '[Last] dddd ha',
            sameElse: 'DD MMM YY ha'
        }) : TO_BE_CONFIRMED;
    } catch (err) {
        return 'N/A';
    }
};

export const mapUtcDateWithoutTime = (dateUtc: string): string => {
    try {
        return  dateUtc ? moment.utc(dateUtc).local().calendar(null, {
            sameDay: '[Today]',
            nextDay: '[Tomorrow]',
            nextWeek: 'dddd',
            lastDay: '[Yesterday]',
            lastWeek: '[Last] dddd',
            sameElse: 'DD MMM YY'
        }) : TO_BE_CONFIRMED;
    } catch (err) {
        return 'N/A';
    }
};

export const mapUtcToDateTimeRelative = (dateUtc: string): string => {
    try {
        if (!dateUtc) {
            return 'N/A';
        }
        return  moment.utc(dateUtc).local().calendar(null, {
            sameDay: '[Today] hh:mma' ,
            nextDay: '[Tomorrow] hh:mma',
            nextWeek: 'dddd hh:mma',
            lastDay: '[Yesterday] hh:mma',
            lastWeek: '[Last] dddd hh:mma',
            sameElse: 'DD MMM YYYY [-] hh:mma'
        });
    } catch (err) {
        return 'N/A';
    }
};
